// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Caml_exceptions = require("rescript/lib/js/caml_exceptions.js");
var Nps$ReactHooksTemplate = require("./Nps.res.js");
var Csat$ReactHooksTemplate = require("./csat.res.js");
var LongText$ReactHooksTemplate = require("./LongText.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var TextType$ReactHooksTemplate = require("../data_fields/textType.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var ShortText$ReactHooksTemplate = require("./ShortText.res.js");
var StarRating$ReactHooksTemplate = require("./StarRating.res.js");
var MobileNumber$ReactHooksTemplate = require("./MobileNumber.res.js");
var OpinionScale$ReactHooksTemplate = require("./OpinionScale.res.js");
var SmileyRating$ReactHooksTemplate = require("./smileyRating.res.js");

var AnswerNotFound = /* @__PURE__ */Caml_exceptions.create("DateCondition-ReactHooksTemplate.AnswerNotFound");

function lhs(t) {
  return t.lhs;
}

function operator(t) {
  return t.operator;
}

function rhs(t) {
  return t.rhs;
}

function setLhs(t, lhs) {
  return {
          lhs: lhs,
          operator: t.operator,
          rhs: t.rhs
        };
}

function setOperator(t, operator) {
  return {
          lhs: t.lhs,
          operator: operator,
          rhs: t.rhs
        };
}

function setRhs(t, rhs) {
  return {
          lhs: t.lhs,
          operator: t.operator,
          rhs: rhs
        };
}

function getAnswer(question) {
  var longText = question.questionType;
  switch (longText.TAG) {
    case "LongText" :
        return LongText$ReactHooksTemplate.answerToString(longText._0);
    case "ShortText" :
        return ShortText$ReactHooksTemplate.answerToString(longText._0);
    case "MobileNumber" :
        return MobileNumber$ReactHooksTemplate.answerToString(longText._0);
    default:
      return ;
  }
}

function getValue(dataField) {
  var textType = DataField$ReactHooksTemplate.dataType(dataField);
  if (textType.TAG === "TextType") {
    return TextType$ReactHooksTemplate.value(textType._0);
  }
  
}

function humanizeOperator(text) {
  switch (text) {
    case "contains" :
        return "Contains";
    case "equals" :
        return "Equals";
    case "not_contains" :
        return "Not Contains";
    case "not_equals" :
        return "Not Equals";
    default:
      return "";
  }
}

function evaluate(t) {
  var question = t.lhs;
  if (question.TAG === "Question") {
    var question$1 = question._0;
    if (Question$ReactHooksTemplate.answered(question$1)) {
      var x = getAnswer(question$1);
      if (x !== undefined) {
        var match = t.operator;
        switch (match) {
          case "contains" :
              return Js_string.includes(x, t.rhs);
          case "equals" :
              return x === t.rhs;
          case "not_contains" :
              return !Js_string.includes(x, t.rhs);
          case "not_equals" :
              return x !== t.rhs;
          default:
            return false;
        }
      } else {
        throw {
              RE_EXN_ID: AnswerNotFound,
              _1: "The Answer Not Found",
              Error: new Error()
            };
      }
    } else {
      throw {
            RE_EXN_ID: AnswerNotFound,
            _1: "The Answer Not Found",
            Error: new Error()
          };
    }
  } else {
    var x$1 = getValue(question._0);
    if (x$1 === undefined) {
      return false;
    }
    var match$1 = t.operator;
    switch (match$1) {
      case "contains" :
          return Js_string.includes(x$1, t.rhs);
      case "equals" :
          return x$1 === t.rhs;
      case "not_contains" :
          return !Js_string.includes(x$1, t.rhs);
      case "not_equals" :
          return x$1 !== t.rhs;
      default:
        return false;
    }
  }
}

function availableOperators(param) {
  return {
          hd: "equals",
          tl: {
            hd: "not_equals",
            tl: {
              hd: "greater_than",
              tl: {
                hd: "less_than",
                tl: {
                  hd: "greater_than_or_equal_to",
                  tl: {
                    hd: "less_than_or_equal_to",
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        };
}

function decodeLhs(json, questions, dataFields) {
  var lhsId = Json_decode.field("lhs_id", Json_decode.$$int, json);
  var lhsType = Json_decode.field("lhs_type", Json_decode.string, json);
  switch (lhsType) {
    case "DataField" :
        return {
                TAG: "DataField",
                _0: List.find((function (n) {
                        return Belt_Option.getExn(DataField$ReactHooksTemplate.id(n)) === lhsId;
                      }), dataFields)
              };
    case "Question" :
        return {
                TAG: "Question",
                _0: List.find((function (n) {
                        return Belt_Option.getExn(Question$ReactHooksTemplate.id(n)) === lhsId;
                      }), questions)
              };
    default:
      return Js_exn.raiseError("Unknown lhs type");
  }
}

function decode(json, questions, dataFields) {
  return {
          lhs: decodeLhs(json, questions, dataFields),
          operator: Json_decode.field("operator", Json_decode.string, json),
          rhs: Json_decode.field("rhs", Json_decode.string, json)
        };
}

function answerRange(question) {
  var nps = question.questionType;
  switch (nps.TAG) {
    case "OpinionScale" :
        return OpinionScale$ReactHooksTemplate.answerRange(nps._0);
    case "StarRating" :
        return StarRating$ReactHooksTemplate.answerRange(nps._0);
    case "Nps" :
        return Nps$ReactHooksTemplate.answerRange(nps._0);
    case "SmileyRating" :
        return SmileyRating$ReactHooksTemplate.answerRange(nps._0);
    case "Csat" :
        return Csat$ReactHooksTemplate.answerRange(nps._0);
    default:
      return [
              0,
              0
            ];
  }
}

function encodeRhs(t) {
  return t.rhs;
}

exports.lhs = lhs;
exports.operator = operator;
exports.rhs = rhs;
exports.setLhs = setLhs;
exports.setOperator = setOperator;
exports.setRhs = setRhs;
exports.evaluate = evaluate;
exports.availableOperators = availableOperators;
exports.decode = decode;
exports.answerRange = answerRange;
exports.humanizeOperator = humanizeOperator;
exports.encodeRhs = encodeRhs;
/* Nps-ReactHooksTemplate Not a pure module */
